import React from "react";
import Countdown from './Countdown'
import CopyView from './CopyView'
import { DepositHeader } from '../index'
import Modal from "./Modal";
import SuccessPageCon from '$Deposits/Components/Components/SuccessPage'
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import Router from "next/router";

class SuccessPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {

        return (
            <>
                <SuccessPageCon
                    SuccessPage={(propCon) => {
                        const {
                            MethodsActive,
                            DepositPayments,
                            HistoryClick,
                            onChange,
                            backClick,
                            money,
                            uniqueAmount,
                            LivechatClick,
                            DepositBouns,
                            bonusName,
                            BackClick,
                            times = 600,
                            BackMyPromo
                        } = propCon
                        const { transactionId } = DepositPayments || {}
                        const amount = numberWithCommas(uniqueAmount || money)
                        const isAmountConverted = Number(uniqueAmount) !== Number(money)
                        let isGetBound = false
                        return (
                            <div className='sucessModal'>
                                <div className='sucessModalCenter'>
                                    <div className="viewArea">
                                        <div className="successIcon"><span></span></div>
                                        <p className="successTitle">ส่งเรียบร้อยแล้ว</p>

                                        <div className="steps">
                                            <div className="stepsList">
                                                <span className="stepIcon" />
                                                <span className="stepA">ส่งเรียบร้อยแล้ว</span>
                                            </div>
                                            <div className="stepsList">
                                                <span className="borders" />
                                                <span className="borderItem">กำลังดำเนินการ</span>
                                            </div>
                                            <div className="stepsList">
                                                <span className="rounds" />
                                                <span className="roundsItem">รอดำเนินการ <Countdown times={times} /> นาที</span>
                                            </div>
                                        </div>

                                        {/* 金额 */}
                                        <div className={`amount ${isAmountConverted ? "hasOrigin" : ""}`}>
                                            <span className='amountTitle'>ยอดฝาก</span>
                                            <div>
                                                <span className='amountValue'>฿ {numberWithCommas(amount)}</span>
                                                {/* 原金額 只有LB Unique Amoumt & LB QR Pay需顯示 */}
                                                { isAmountConverted && <div className="amountOrigin">ยอดรายการ: {numberWithCommas(Number(money))}</div>} 
                                            </div>
                                        </div>
                                        

                                        <CopyView
                                            copyTitle={'หมายเลขธุรกรรม'}
                                            copyValue={transactionId}
                                            copyType={'transactionId'}
                                        />
                                    </div>

                                    {
                                        isGetBound &&
                                        <div className="offerDetails">
                                            <span className="offerTitle">{bonusName}</span>
                                            <div className="offerItem">
                                                <div>โบนัสที่ขอรับ</div>
                                                <div>฿ {money == "" ? "0" : numberWithCommas(money, 2)}</div>
                                            </div>
                                            <div className="offerItem">
                                                <div>โบนัสที่ได้รับ</div>
                                                <div>฿ {numberWithCommas(DepositBouns?.BonusAmount, 2)}</div>
                                            </div>
                                            <div className="offerItem">
                                                <div>ยอดเทิร์นของโบนัส</div>
                                                <div>฿ {numberWithCommas(DepositBouns?.TurnoverAmount, 2)}</div>
                                            </div>
                                        </div>
                                    }

                                    <div onClick={LivechatClick} className="successTrips">
                                        รายการฝากจะปรับเข้าสู่บัญชีอัตโนมัติเมื่อทำการโอนเงินสำเร็จ<br />
                                        หากมีคำถามกรุณาติดต่อฝ่ายบริการลูกค้า
                                    </div>
                                    {
                                        isGetBound ? (
                                            <>
                                                <div
                                                    className={'submitBtnActive'}
                                                    onClick={()=>{ BackMyPromo() }}
                                                >
                                                    ตรวจสอบสถานะโปรโมชั่น
                                                </div>
                                                    <div
                                                        className={'submitBorderActive'}
                                                        onClick={BackClick}
                                                    >
                                                    กลับสู่หน้าหลัก
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    className={'submitBtnActive'}
                                                    onClick={HistoryClick}
                                                >
                                                    กลับสู่หน้าประวัติรายการ
                                                </div>

                                                <div
                                                    className={'submitBorderActive'}
                                                    onClick={onChange}
                                                >
                                                    กลับสู่หน้าฝาก
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }}

                />

            </>
        );
    }
}

export default SuccessPage


